import { useUserInfo } from '@/hooks/hooks';
import { Navigate } from 'react-router-dom';

const Root = () => {
  const userInfo = useUserInfo();
  if (userInfo.userType === 'ADMIN') {
    return <Navigate to="/mana" replace></Navigate>;
  }
  if (userInfo.userType === 'EDU') {
    return <Navigate to="/front" replace></Navigate>;
  }
  if (userInfo.userType === 'TEACHER') {
    return <Navigate to="/front" replace></Navigate>;
  }
  return <Navigate to="/mana" replace></Navigate>;
};

export default Root;